module.exports = __webpack_public_path__ + "static/img/ServicePersonnel.6873c02b.png";